import { useState } from 'react';
import { MainLayout } from '@templates/index';
import { LEGAL_CONFIG } from '@/config/legal';
import { Link } from 'react-router-dom';
import { cn } from '@/utils/cn';

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqCategory {
  title: string;
  icon: string;
  items: FaqItem[];
}

const FAQ_DATA: FaqCategory[] = [
  {
    title: 'Sipariş Verme',
    icon: '🛒',
    items: [
      {
        question: 'Nasıl sipariş verebilirim?',
        answer:
          'Uygulamayı veya web sitemizi açın, konumunuzu belirleyin, size yakın restoranlardan birini seçin, menüden ürünleri sepetinize ekleyin ve ödeme adımını tamamlayın. Siparişiniz restorana iletilir ve hazırlandıktan sonra kurye tarafından adresinize teslim edilir.',
      },
      {
        question: 'Minimum sipariş tutarı var mı?',
        answer:
          'Minimum sipariş tutarı restorandan restorana farklılık gösterir. Restoran sayfasında ilgili bilgiyi görebilirsiniz. Minimum tutarın altında sipariş verilmesi durumunda sistem sizi uyaracaktır.',
      },
      {
        question: 'Siparişime özel not ekleyebilir miyim?',
        answer:
          'Evet. Ödeme sayfasında "Sipariş Notu" alanına restoran için özel taleplerinizi (alerji bilgisi, pişirme tercihi vb.) yazabilirsiniz. Notunuz doğrudan restorana iletilir.',
      },
      {
        question: 'Aynı anda birden fazla restorandan sipariş verebilir miyim?',
        answer:
          'Hayır. Sepetiniz tek bir restorana aittir. Farklı bir restorandan ürün eklemek istediğinizde mevcut sepetinizi temizlemeniz gerekir.',
      },
    ],
  },
  {
    title: 'Teslimat',
    icon: '🚴',
    items: [
      {
        question: 'Teslimat süresi ne kadar?',
        answer:
          'Ortalama teslimat süremiz 25–45 dakikadır. Tahmini süre, restoran hazırlık süresi ve konumunuza göre değişir. Siparişinizi verdikten sonra gerçek zamanlı takip ekranından anlık durumu izleyebilirsiniz.',
      },
      {
        question: 'Siparişimi gerçek zamanlı takip edebilir miyim?',
        answer:
          'Evet. Sipariş onaylandıktan sonra "Siparişlerim" bölümünden veya size gönderilen bildirimden takip ekranına ulaşabilirsiniz. Kuryenin konumunu harita üzerinde canlı olarak görebilirsiniz.',
      },
      {
        question: 'Teslimat ücreti ne kadar?',
        answer:
          'Teslimat ücreti restoran ve konumunuza göre değişir. Sepet özeti ekranında ödeme yapmadan önce teslimat ücreti açıkça gösterilir. Bazı restoranlar belirli bir tutar üzerindeki siparişlerde ücretsiz teslimat sunabilir.',
      },
      {
        question: 'Siparişim geç gelirse ne yapmalıyım?',
        answer:
          'Tahmini teslimat süresi geçmişse destek ekibimizle iletişime geçebilirsiniz. Destek talebi oluşturmak için "Destek" sayfasını ziyaret edin veya destek@lezzetyolda.com adresine yazın.',
      },
    ],
  },
  {
    title: 'Ödeme',
    icon: '💳',
    items: [
      {
        question: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
        answer:
          'Kredi kartı, banka kartı ve kapıda nakit ödeme seçeneklerini destekliyoruz. Ödeme altyapımız PCI-DSS uyumludur; kart bilgileriniz güvenli şekilde tokenize edilir, ham kart numarası sistemlerimizde saklanmaz.',
      },
      {
        question: 'Ödeme güvenli mi?',
        answer:
          'Evet. Tüm ödeme işlemleri SSL/TLS şifrelemesi ve PCI-DSS uyumlu altyapı üzerinden gerçekleştirilir. Kart bilgileriniz lisanslı ödeme hizmeti sağlayıcısı tarafından güvenle işlenir.',
      },
      {
        question: 'Fatura alabilir miyim?',
        answer:
          'Evet. Sipariş tamamlandıktan sonra kayıtlı e-posta adresinize fatura gönderilir. Kurumsal fatura talepleriniz için destek ekibimizle iletişime geçebilirsiniz.',
      },
    ],
  },
  {
    title: 'İptal ve İade',
    icon: '↩️',
    items: [
      {
        question: 'Siparişimi iptal edebilir miyim?',
        answer:
          'Restoran siparişinizi henüz "Hazırlanıyor" durumuna almamışsa iptal edebilirsiniz. Hazırlık başladıktan sonra iptal mümkün olmayabilir. İptal talebiniz için "Siparişlerim" bölümünden ilgili siparişi seçin.',
      },
      {
        question: 'Yanlış veya eksik ürün geldiyse ne yapmalıyım?',
        answer:
          'Teslimat sırasında veya hemen ardından destek ekibimize bildirin. Geçerli şikayetlerde ücret iadesi veya ürünün yeniden gönderimi sağlanır. Destek talebi oluşturmak için "Destek" sayfasını kullanabilirsiniz.',
      },
      {
        question: 'İade ne zaman hesabıma yansır?',
        answer:
          'Onaylanan iade işlemleri, ödeme yönteminize bağlı olarak 1–10 iş günü içinde hesabınıza yansıtılır. Kredi kartı iadeleri bankanızın işlem süresine göre değişebilir.',
      },
      {
        question: 'Gıda ürünlerinde iade hakkım var mı?',
        answer:
          'Mesafeli Sözleşmeler Yönetmeliği uyarınca, hazırlanmış ve teslim edilmiş gıda ürünlerinde genel iade hakkı bulunmamaktadır. Ancak yanlış, eksik veya hasarlı teslimat durumlarında iade veya telafi sağlanır.',
      },
    ],
  },
  {
    title: 'Hesap ve Üyelik',
    icon: '👤',
    items: [
      {
        question: 'Üyelik ücretsiz mi?',
        answer:
          'Evet. Lezzet Yolda platformuna üyelik tamamen ücretsizdir. Yalnızca verdiğiniz siparişler için ödeme yaparsınız.',
      },
      {
        question: 'Şifremi unuttum, ne yapmalıyım?',
        answer:
          'Giriş sayfasındaki "Şifremi Unuttum" bağlantısına tıklayın. Kayıtlı e-posta adresinize şifre sıfırlama bağlantısı gönderilecektir.',
      },
      {
        question: 'Hesabımı nasıl silebilirim?',
        answer:
          'Mobil uygulamada Profil → Hesabı Kapat adımlarını izleyerek hesabınızı kalıcı olarak silebilirsiniz. Hesap silme işlemi geri alınamaz; profil ve adres bilgileriniz kaldırılır, geçmiş siparişler yasal gereklilikler kapsamında anonim olarak saklanabilir.',
      },
      {
        question: 'Kişisel verilerimi nasıl güncelleyebilirim?',
        answer:
          'Profil sayfasından ad, soyad, telefon ve e-posta bilgilerinizi güncelleyebilirsiniz. KVKK kapsamındaki veri talepleriniz için destek@lezzetyolda.com adresine yazabilirsiniz.',
      },
    ],
  },
];

function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="space-y-2">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className="border border-gray-200 rounded-xl overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(isOpen ? null : index)}
              className="w-full flex items-center justify-between px-5 py-4 text-left bg-white hover:bg-gray-50 transition-colors"
            >
              <span className="font-medium text-gray-900 text-sm pr-4">{item.question}</span>
              <span
                className={cn(
                  'shrink-0 w-5 h-5 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 transition-transform duration-200',
                  isOpen && 'rotate-180 border-[#E63946] text-[#E63946]'
                )}
              >
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-5 bg-white">
                <p className="text-gray-600 text-sm leading-relaxed">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

const FaqPage = () => {
  const [activeCategory, setActiveCategory] = useState(0);

  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto py-12 px-4">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Sıkça Sorulan Sorular</h1>
          <p className="text-gray-500 max-w-xl mx-auto">
            Aradığınız cevabı bulamadıysanız{' '}
            <Link to="/contact" className="text-[#E63946] hover:underline font-medium">
              iletişim sayfamızdan
            </Link>{' '}
            bize ulaşabilirsiniz.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8">
          {/* Category Nav */}
          <aside className="md:w-48 shrink-0">
            <nav className="flex md:flex-col gap-2 overflow-x-auto md:overflow-visible pb-2 md:pb-0">
              {FAQ_DATA.map((cat, index) => (
                <button
                  key={index}
                  onClick={() => setActiveCategory(index)}
                  className={cn(
                    'flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap transition-all text-left',
                    activeCategory === index
                      ? 'bg-[#E63946] text-white'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  <span>{cat.icon}</span>
                  <span>{cat.title}</span>
                </button>
              ))}
            </nav>
          </aside>

          {/* FAQ Content */}
          <div className="flex-1 min-w-0">
            <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
              <span>{FAQ_DATA[activeCategory].icon}</span>
              <span>{FAQ_DATA[activeCategory].title}</span>
            </h2>
            <FaqAccordion items={FAQ_DATA[activeCategory].items} />
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 p-6 bg-gray-50 rounded-2xl border border-gray-200 text-center">
          <p className="text-gray-700 font-medium mb-1">Sorunuzu bulamadınız mı?</p>
          <p className="text-gray-500 text-sm mb-4">
            Destek ekibimiz size yardımcı olmaktan memnuniyet duyar.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/support"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#E63946] text-white rounded-xl text-sm font-semibold hover:bg-red-600 transition-colors"
            >
              Destek Talebi Oluştur
            </Link>
            <a
              href={`mailto:${LEGAL_CONFIG.email}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-gray-300 text-gray-700 rounded-xl text-sm font-semibold hover:bg-gray-100 transition-colors"
            >
              {LEGAL_CONFIG.email}
            </a>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default FaqPage;
